import { IReminder } from '@alberta/konexi-shared';
import { Inject, Injectable } from '@angular/core';
import { BaseComponentModel } from 'src/app/common/component-model/base-component-model';
import { ComponentModelDependencies } from 'src/app/common/component-model/component-model-dependencies';
import { ComponentModelInfo } from 'src/app/common/component-model/component-model-info';
import { ReminderModelName } from 'src/app/shared/models/model-names';

@Injectable({ providedIn: 'root' })
export class ReminderComponentModel extends BaseComponentModel<IReminder> {
  /**
   * ComponentModel for all article relevant actions and dependencies
   */
  constructor(
    @Inject(ComponentModelDependencies) componentModelDependencies: ComponentModelDependencies,
    @Inject(ComponentModelInfo) componentModelInfo: ComponentModelInfo
  ) {
    super(ReminderModelName, componentModelDependencies, componentModelInfo);
  }
}
